<template>
  <div class="account_container">
    <div class="main-content">
      <el-tabs v-model="activeName">
        <el-tab-pane label="Friends" name="second">
          <div class="friendTop">
            <div>{{ $t('invite_link') }}:</div>
            <div class="shareLink">{{shareLink}}</div>
            <el-button
              class="copy"
              v-clipboard:copy="shareLink"
              v-clipboard:success="copy"
            >{{ $t('copy') }}</el-button>
          </div>
          <!-- invite code hidden -->
          <!-- <div class="friendTop">
            <div>{{ $t('invite_code') }}:</div>
            <div class="inviteCode">{{inviteCode}}</div>
            <el-button
              class="copy"
              v-clipboard:copy="inviteCode"
              v-clipboard:success="copy"
            >{{ $t('copy') }}</el-button>
          </div> -->
          <div class="friendDetail">
            <div class="conleft">
              Receive reward points for every purchase you or your friends make!
              <br />Cash out your points to get money back. Buy more get more!
              <i class="el-icon-question" @click="friendDia = true"></i>
            </div>
            <div class="conright">
              <span @click="myInviteDia = true">{{ $t('myInvites') }}</span>
            </div>
          </div>
          <div class="friendList" v-if="true">
            <!-- <ul>
                    <li v-for="(item,index) in 10" :key="index">
                        <img src="../../assets/img/Convi.png" class="avatar" alt="">
                        <div class="name">Name</div>
                        <div class="date">2020/08/20</div>
                        <div class="give">$ 100</div>
                    </li>
            </ul>-->
            <div class="vis">
              <Vis></Vis>
            </div>
            <div class="revenue">
              <div class="total">
                <div>{{ $t('points') }}</div>
                <!-- <i class="el-icon-question" @click="integralDia = true"></i> -->
              </div>
              <div class="money">
                <!-- <div class="integral">300</div> -->
                <div class="integral">{{enablePoints}}</div>
                <div class="dol">≈ ${{availableCash}}</div>
              </div>
              <div class="withdrawBtn" @click="withdrawDia = true">{{ $t('withdraw') }}</div>
              <div class="withdrawBtn" @click="historyDia = true">{{ $t('history') }}</div>
            </div>
          </div>
          <div v-else>暂无邀请人</div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <el-dialog title=" " :visible.sync="friendDia" class="modal">
      <div class="title">邀请有奖</div>
      <p>
        您每邀请一个好友登陆注册，此好友即将成为你的团伙！
        <br />朋友自人邀请的朋友也是您的团伙！
      </p>
      <p>
        邀请好友成功需要满足以下条件：
        <br />1.需要您的好友实用您的专属链接；
        <br />2.需要您的好友使用连接登陆并注册；
        <br />3.您的IP地址不能与您邀请的好友IP地址相同；
        <br />4.邀请人的所有信息均不能和被邀请人的信息相同；
        <br />5.特殊活动等不参与邀请返利。
        <br />6.积分可来自本人的邀请好友， 或者好友自人的邀请， 包括自己共三级。
        <br />
      </p>
      <el-button class="friendDiaBtn" @click="friendDia = false">OK</el-button>
    </el-dialog>

    <el-dialog title="积分" :visible.sync="integralDia" class="integralDia">
      <el-table :data="integralData">
        <el-table-column property="date" label="日期"></el-table-column>
        <el-table-column property="name" label="姓名"></el-table-column>
        <el-table-column property="integral" label="积分" width="80"></el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog :title="$t('withdraw')" :visible.sync="withdrawDia" class="integralDia withdraw">
      <div class="withdrawTop">
        <el-form
          :model="withdrawData"
          ref="withdrawFrom"
          :rules="withdrawRules"
          label-width="150px"
          class="withdrawFrom"
        >
          <el-form-item v-bind:label="$t('withdraw_type')">
            <el-radio-group v-model="withdrawData.WithdrawType">
              <el-radio label="bank_transfer">{{ $t('bank_transfer') }}</el-radio>
              <el-radio label="check">{{ $t('check') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-bind:label="$t('account_balance')">
            <span class="num">${{availableCash}}</span>
          </el-form-item>
          <el-form-item v-bind:label="$t('withdraw_amount')" prop="WithdrawDollar">
            <el-input-number
              :min="0"
              :max="Number(availableCash)"
              v-model="withdrawData.WithdrawDollar"
            ></el-input-number>
          </el-form-item>
          <el-form-item v-bind:label="$t('firstName')" prop="WithdrawFirstName">
            <el-input v-model="withdrawData.WithdrawFirstName"></el-input>
          </el-form-item>
          <el-form-item v-bind:label="$t('lastName')" prop="WithdrawLastName">
            <el-input v-model="withdrawData.WithdrawLastName"></el-input>
          </el-form-item>

          <div v-if="withdrawData.WithdrawType === 'bank_transfer'">
            <el-form-item v-bind:label="$t('routing_number')" prop="WithdrawRoutingNum">
              <el-input v-model="withdrawData.WithdrawRoutingNum"></el-input>
            </el-form-item>
            <el-form-item v-bind:label="$t('account_number')" prop="WithdrawAccountNum">
              <el-input v-model="withdrawData.WithdrawAccountNum"></el-input>
            </el-form-item>
          </div>

          <div v-if="withdrawData.WithdrawType === 'check'">
            <el-form-item v-bind:label="$t('check_title')" prop="WithdrawCheckTitle">
              <el-input v-model="withdrawData.WithdrawCheckTitle"></el-input>
            </el-form-item>
            <el-form-item v-bind:label="$t('email')" prop="WithdrawEmail">
              <el-input v-model="withdrawData.WithdrawEmail"></el-input>
            </el-form-item>
          </div>

          <el-form-item v-bind:label="$t('address')" prop="WithdrawAddress">
            <el-input v-model="withdrawData.WithdrawAddress"></el-input>
          </el-form-item>
          <el-form-item v-bind:label="$t('city')" prop="WithdrawCity">
            <el-input v-model="withdrawData.WithdrawCity"></el-input>
          </el-form-item>

          <!-- <el-form-item v-bind:label="$t('state')" prop="WithdrawState">
            <el-input v-model="withdrawData.WithdrawState"></el-input>
          </el-form-item>-->
          <el-form-item v-bind:label="$t('state')" prop="WithdrawState">
            <el-select v-model="withdrawData.WithdrawState" value>
              <el-option
                v-for="item in stateOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-bind:label="$t('zipCode')" prop="WithdrawZipcode">
            <el-input v-model="withdrawData.WithdrawZipcode"></el-input>
          </el-form-item>
        </el-form>
        <el-button type="primary" class="withBtn" @click="submitWithdraw">{{ $t('submit') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('withdraw_history')"
      :visible.sync="historyDia"
      class="historyDia withdraw"
    >
      <div class="withdrawBot">
        <!-- <div class="title">{{ $t('withdraw_history') }}</div> -->
        <el-table :data="withdrawHistoryData" border>
          <el-table-column property="CreateTime" :label="$t('create_time')" min-width="120"></el-table-column>
          <el-table-column property="WithdrawType" :label="$t('withdraw_type')" min-width="120"></el-table-column>
          <el-table-column property="WithdrawDollar" :label="$t('amount$')" min-width="100"></el-table-column>
          <el-table-column property="Points" :label="$t('points_used')" min-width="100"></el-table-column>
          <el-table-column property="WithdrawStatus" :label="$t('status')" min-width="100"></el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('myInvites')"
      :visible.sync="myInviteDia"
      class="myInviteDia"
    >
    <InviteGraph></InviteGraph>
    </el-dialog>

  </div>
</template>

<script>
// import {} from 'vuex';
import Vis from "../../components/vis";
import InviteGraph from '../../components/invitegraph';
import Chart from 'chart.js';
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  name: "friends",
  components: {
    Vis,
    InviteGraph,
  },
  data() {
    return {
      activeName: "second",
      enablePoints: 0,
      availableCash: 0,
      shareLink: "https://www.morningplaza.com/register/",
      inviteCode: "",
      withdrawDia: false,
      withdrawError: false,
      withdrawData: {
        Remark: "withdraw",
        Type: "out",
        WithdrawType: "bank_transfer",
        WithdrawDollar: 0,

        WithdrawFirstName: "",
        WithdrawLastName: "",
        WithdrawAddress: "",
        WithdrawCity: "",
        WithdrawState: "CA",
        WithdrawZipcode: "",

        WithdrawRoutingNum: "",
        WithdrawAccountNum: "",
        WithdrawEmail: "",
        WithdrawCheckTitle: "",
      },
      withdrawRules: {
        WithdrawDollar: [
          {
            required: true,
            message: "Withdraw amount is required",
            trigger: "blur",
          },
        ],
        WithdrawFirstName: [
          {
            required: true,
            message: "First name is required",
            // message: this.$t('firstNameRequired'),
            trigger: "blur",
          },
        ],
        WithdrawLastName: [
          { required: true, message: "Last name is required", trigger: "blur" },
        ],
        WithdrawAddress: [
          { required: true, message: "Address is required", trigger: "blur" },
        ],
        WithdrawCity: [
          { required: true, message: "City is required", trigger: "blur" },
        ],
        WithdrawZipcode: [
          { required: true, message: "Zip code is required", trigger: "blur" },
          {
            min: 3,
            max: 30,
            message: "Zip code length at least 3",
            trigger: "blur",
          },
        ],

        WithdrawRoutingNum: [
          {
            required: true,
            message: "Routing number is required",
            trigger: "blur",
          },
        ],
        WithdrawAccountNum: [
          {
            required: true,
            message: "Routing number is required",
            trigger: "blur",
          },
        ],

        WithdrawEmail: [
          { required: true, message: "Email is required", trigger: "blur" },
        ],
        WithdrawCheckTitle: [
          {
            required: true,
            message: "Check title is required",
            trigger: "blur",
          },
        ],
      },

      friendDia: false,
      myInviteDia: false,
      integralDia: false,
      integralData: [
        {
          date: "2020-02-20",
          name: "邀请的人名字",
          integral: "+100",
        },
        {
          date: "2020-02-20",
          name: "dfhasf_kandfsn_dmfls",
          integral: "+100",
        },
      ],

      historyDia: false,
      withdrawHistory: [
        {
          date: "2020-02-20",
          num: "100",
          type: "Bank Account",
          status: "完成",
        },
        {
          date: "2020-02-20",
          num: "100",
          type: "Bank Account",
          status: "完成",
        },
        {
          date: "2020-02-20",
          num: "100",
          type: "Bank Account",
          status: "完成",
        },
      ],

      stateOptions: this.$store.state.addresses.states, // States drop down data
    };
  },
  methods: {
    ...mapActions("addresses", ["fetchWithdraw", "fetchMLMNetwork", "fetchInviteHistory"]),
    checkWithdrawData(data) {
      console.log("checking data", data);
      if (
        !data.WithdrawFirstName ||
        !data.WithdrawLastName ||
        !data.WithdrawAddress ||
        !data.WithdrawCity ||
        !data.WithdrawZipcode
      ) {
        this.withdrawError = true;
        alert("Please fill in all required inputs *");
        return;
      }

      if (data.WithdrawType === "bank_transfer") {
        if (!data.WithdrawAccountNum || !data.WithdrawRoutingNum) {
          this.withdrawError = true;
          alert("Please fill in required bank information *");
          return;
        }
      }

      if (data.WithdrawType === "check") {
        if (!data.WithdrawEmail || !data.WithdrawCheckTitle) {
          this.withdrawError = true;
          alert("Please fill in required check information *");
          return;
        }
      }

      // this.withdrawError = true; // for testing
    },
    submitWithdraw() {
      this.checkWithdrawData(this.withdrawData);
      if (this.withdrawError === false) {
        this.$store.dispatch("addresses/postWithdraw", this.withdrawData).then(
          (response) => {
            this.$notify({
              type: "success",
              title: this.$t("withdraw_submitted"),
              position: "bottom-right",
              duration: 5000,
            });
            this.withdrawDia = false;
            this.fetchMLMNetwork(this.userDetails.mobile_user_id);
            this.withdrawData = {
              Remark: "withdraw",
              Type: "out",
              WithdrawType: "bank_transfer",
              WithdrawDollar: 0,

              WithdrawFirstName: "",
              WithdrawLastName: "",
              WithdrawAddress: "",
              WithdrawCity: "",
              WithdrawState: "CA",
              WithdrawZipcode: "",

              WithdrawRoutingNum: "",
              WithdrawAccountNum: "",
              WithdrawEmail: "",
              WithdrawCheckTitle: "",
            };
          },
          (err) => {
            // if (err.response.status === 400 || err.response.status === 500) {}
            if (err.response.data) {
              alert(err.response.data);
            } else {
              alert("Withdraw error, please contact us.");
            }
          }
        );
      } else {
        // alert("Please fill in all required inputs *");
      }
    },
    copy() {
      this.$notify({
        type: "success",
        title: "复制成功",
        // message: "发送链接邀请好友",
        position: "bottom-right",
        duration: 2000,
      });
    },
    handleClose() {
      this.drawer = false;
    },
  },
  mounted() {
  },
  computed: mapState({
    networkData: (state) => state.addresses.networkData,
    userDetails: (state) => state.auth.userDetails,
    withdrawHistoryData: (state) => state.addresses.withdrawHistoryData,
  }),
  watch: {
    myInviteDia: function (newVal, oldVal) {
      if (newVal === true) {
        this.fetchInviteHistory();
      }
    },
    historyDia: function (newVal, oldVal) {
      if (newVal === true) {
        this.fetchWithdraw(this.userDetails.mobile_user_id);
      }
    },
    networkData: function (newVal, oldVal) {
      if (newVal && newVal[0] && (newVal[0].EnablePoints || newVal[0].EnablePoints >= 0)) {
        this.enablePoints = Math.floor(newVal[0].EnablePoints);
        this.availableCash = newVal[0].AvailableCash.toFixed(2);
        this.shareLink =
          "https://www.morningplaza.com/register/" + newVal[0].id;
        this.inviteCode = newVal[0].id;
      } else {
        this.enablePoints = 0;
        this.availableCash = 0;
      }
    },
  },
};
</script>
<style scoped lang="less">
@import "../../assets/css/friends.less";
</style>



// WEBPACK FOOTER //
// src/view/Profile/friends.vue